export const articles = [
  {
    id: 'article-001',
    title: '顶流男星隐婚生子实锤曝光！酒店监控画面流出，粉丝集体崩溃',
    summary: '某顶流男星被拍到与神秘女子同入酒店长达三小时，更有知情人爆料两人已秘密结婚并育有一子，女方身份疑似圈内知名经纪人。',
    category: 'celebrity',
    categoryName: '明星八卦',
    author: '爆料小助手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20female%20journalist%20with%20confident%20expression%2C%20neutral%20warm%20background%2C%20clean%20studio%20lighting%2C%20soft%20natural%20light&width=100&height=100&seq=avatar-001&orientation=squarish',
    publishDate: '2026-07-02',
    readTime: '5分钟',
    hotValue: 12850,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20night%20photography%20outside%20luxury%20hotel%20entrance%20with%20flash%20lights%2C%20celebrity%20atmosphere%2C%20dark%20moody%20cinematic%20tone%2C%20warm%20amber%20street%20lights%20against%20cool%20night%20sky%2C%20editorial%20photography%20style&width=800&height=500&seq=article-001&orientation=landscape',
    tags: ['顶流男星', '隐婚', '酒店', '生子'],
    featured: true,
    content: `
      <p>今日凌晨，一则重磅爆料在社交平台炸开了锅。某拥有超过五千万粉丝的顶流男星，被拍到与一名神秘女子共同出入某五星级酒店，两人举止亲密，明显超出普通朋友关系。</p>
      <p>据酒店内部工作人员透露，该男子与女子在酒店房间共度近三小时后才离开。更劲爆的是，有知情人士爆料称，两人其实早已秘密结婚，并且育有一个两岁的儿子，只是男方为了维持单身人设一直没有公开。</p>
      <p>消息一出，粉丝群体瞬间炸锅。微博话题#顶流男星隐婚生子#在短短两小时内阅读量突破十亿，评论区充斥着粉丝的不信、崩溃和愤怒。不少忠实粉丝表示"房子塌了"，纷纷脱粉。</p>
      <p>目前男方工作室尚未作出回应，但其微博评论区已沦陷，最新一条动态的评论数超过百万条。吃瓜爆料将持续关注此事进展，第一时间为大家带来最新消息。</p>
    `,
  },
  {
    id: 'article-002',
    title: '千万粉丝网红直播翻车！所售燕窝实为糖水，打假博主现场开箱',
    summary: '知名带货网红直播间售卖所谓"天然燕窝"，被专业打假博主购买检测后发现实际成分仅为糖水和增稠剂，成本不足售价的百分之一。',
    category: 'influencer',
    categoryName: '网红黑料',
    author: '打假先锋',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20male%20investigator%20with%20serious%20expression%2C%20wearing%20casual%20blazer%2C%20neutral%20warm%20background%2C%20clean%20studio%20lighting&width=100&height=100&seq=avatar-002&orientation=squarish',
    publishDate: '2026-07-01',
    readTime: '4分钟',
    hotValue: 9870,
    image: 'https://readdy.ai/api/search-image?query=Professional%20product%20photography%20of%20glass%20jar%20with%20clear%20syrupy%20liquid%20on%20laboratory%20table%2C%20scientific%20testing%20equipment%20in%20background%2C%20clean%20modern%20aesthetic%2C%20warm%20neutral%20tones%2C%20editorial%20style%20photography&width=800&height=500&seq=article-002&orientation=landscape',
    tags: ['网红翻车', '带货', '燕窝', '打假'],
    featured: true,
    content: `
      <p>昨日晚间，拥有千万粉丝的头部带货主播"小美优选"在直播间大力推销一款号称"马来西亚纯天然进口燕窝"的产品，售价高达每盒299元，短短十分钟售出超过十万盒。</p>
      <p>然而，知名打假博主"真相只有一个"在直播间下单购买后，立即送往专业检测机构进行成分分析。检测结果令人震惊——该产品燕窝含量为零，实际成分为水、白砂糖、增稠剂和食用香精，单盒成本不足两元。</p>
      <p>打假博主连夜制作开箱对比视频，将正品燕窝与该产品进行外观、泡发、口感等多维度对比，差距一目了然。视频发布三小时播放量破千万，评论区大量网友表示"被骗惨了"。</p>
      <p>目前涉事主播已关闭评论区，商品链接也已下架。但消费者维权之路才刚刚开始，吃瓜爆料提醒各位网友：直播带货需谨慎，切勿盲目跟风。</p>
    `,
  },
  {
    id: 'article-003',
    title: '今日吃瓜大赛：顶流男星隐婚 vs 千万网红翻车，你选哪个？',
    summary: '吃瓜爆料每日大赛火热开启！今日两大重磅瓜料同时登场，究竟哪一件更让你震撼？快来投出你神圣的一票！',
    category: 'daily',
    categoryName: '每日大赛',
    author: '吃瓜大赛组委会',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fun%20colorful%20illustration%20of%20a%20watermelon%20slice%20character%20mascot%20with%20smiling%20face%2C%20cute%20cartoon%20style%2C%20vibrant%20colors%2C%20clean%20white%20background&width=100&height=100&seq=avatar-003&orientation=squarish',
    publishDate: '2026-07-02',
    readTime: '2分钟',
    hotValue: 8650,
    image: 'https://readdy.ai/api/search-image?query=Creative%20composition%20of%20two%20giant%20watermelon%20halves%20facing%20each%20other%20in%20competition%20pose%2C%20dramatic%20studio%20lighting%2C%20warm%20amber%20and%20deep%20green%20tones%2C%20editorial%20food%20photography%20style%2C%20playful%20competitive%20atmosphere&width=800&height=500&seq=article-003&orientation=landscape',
    tags: ['每日大赛', '投票', 'PK', '最震撼'],
    featured: true,
    content: `
      <p>欢迎来到吃瓜爆料每日大赛！每天我们都会精选全网最劲爆的瓜料进行PK，由广大瓜友们投票选出"今日最震撼瓜王"。</p>
      <p>今日参赛瓜料：</p>
      <p><strong>选手A：顶流男星隐婚生子实锤</strong></p>
      <p>某五千万粉丝顶流男星被拍到与神秘女子同入酒店，知情人爆料两人已秘密结婚并育有一子。粉丝集体崩溃，微博话题阅读量突破十亿。</p>
      <p><strong>选手B：千万网红带货翻车</strong></p>
      <p>头部带货主播所售"天然燕窝"实为糖水，成本不足售价百分之一。打假博主现场开箱检测，十分钟售出十万盒。</p>
      <p>目前选手A暂时领先，投票占比58%。距离今日投票截止还有6小时，快来投出你的一票，支持你心中的"今日瓜王"！</p>
    `,
  },
  {
    id: 'article-004',
    title: '某上市公司高管出轨女下属，妻子实名举报信曝光全部细节',
    summary: '一封长达三千字的实名举报信在社交平台疯传，某知名上市公司高管被妻子实名举报出轨多名女下属，附大量聊天记录和转账凭证。',
    category: 'social',
    categoryName: '社会热点',
    author: '热点追踪员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20female%20reporter%20with%20determined%20expression%2C%20wearing%20professional%20attire%2C%20neutral%20warm%20studio%20background%2C%20clean%20lighting&width=100&height=100&seq=avatar-004&orientation=squarish',
    publishDate: '2026-06-30',
    readTime: '6分钟',
    hotValue: 15230,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20flat%20lay%20photography%20of%20scattered%20documents%20letters%20and%20printed%20chat%20screenshots%20on%20dark%20wooden%20desk%2C%20moody%20cinematic%20lighting%2C%20warm%20amber%20tones%2C%20investigative%20journalism%20atmosphere%2C%20editorial%20style&width=800&height=500&seq=article-004&orientation=landscape',
    tags: ['上市公司', '高管出轨', '实名举报', '聊天记录'],
    featured: true,
    content: `
      <p>昨日，一封题为《致公司董事会及全体股东的公开信》的三千字长文在社交平台迅速传播，写信人自称是某知名上市公司副总裁的妻子，实名举报丈夫出轨多名女下属。</p>
      <p>信中详细列举了丈夫与三名女下属的不正当关系，并附上了大量微信聊天记录截图、酒店开房记录以及转账凭证。据信中所述，丈夫利用职务之便，为女下属安排不合理晋升，并使用公司资金为其购买奢侈品。</p>
      <p>更劲爆的是，信中透露丈夫曾威胁妻子"如果敢公开就让她净身出户"，妻子表示已经收集证据长达两年，如今决定鱼死网破。</p>
      <p>该公司股价在消息传出后当天下跌超过7%，公司董事会已发布公告表示"正在核实相关情况"。吃瓜爆料将持续跟进此事。</p>
    `,
  },
  {
    id: 'article-005',
    title: '当红小花与导演深夜同归公寓，疑似潜规则上位',
    summary: '媒体拍到某95后当红小花与知名导演深夜先后进入同一公寓楼，三小时后小花独自离开，引发网友对其成名之路的质疑。',
    category: 'celebrity',
    categoryName: '明星八卦',
    author: '娱乐侦察兵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20male%20entertainment%20reporter%20with%20curious%20expression%2C%20casual%20stylish%20outfit%2C%20warm%20neutral%20background%2C%20clean%20studio%20lighting&width=100&height=100&seq=avatar-005&orientation=squarish',
    publishDate: '2026-06-29',
    readTime: '4分钟',
    hotValue: 7890,
    image: 'https://readdy.ai/api/search-image?query=Night%20street%20photography%20of%20luxury%20apartment%20building%20entrance%20with%20warm%20lobby%20lights%20glowing%2C%20dramatic%20shadows%2C%20paparazzi%20style%20atmosphere%2C%20dark%20moody%20cinematic%20tone%2C%20urban%20night%20scene%20editorial%20photography&width=800&height=500&seq=article-005&orientation=landscape',
    tags: ['当红小花', '导演', '潜规则', '公寓'],
    featured: false,
    content: `
      <p>某知名娱乐媒体昨日放出重磅爆料，拍到95后当红小花林某与某知名导演张某深夜先后进入同一高档公寓楼。据视频显示，小花于晚上十一点独自进入公寓，导演则在十五分钟后由助理陪同进入同一楼层。</p>
      <p>三小时后，小花独自离开公寓，全程低头快走，似乎有意躲避镜头。而导演直到次日清晨才离开。</p>
      <p>值得注意的是，这位小花在短短一年内从配角跃升为多部S+级剧的女主角，而她的经纪约正签在该导演旗下的工作室。网友对此纷纷表示"细思极恐"、"娱乐圈水太深"。</p>
      <p>目前双方均未对此作出回应，但小花粉丝后援会已发布声明称"相信偶像清白"。吃瓜爆料将持续关注。</p>
    `,
  },
  {
    id: 'article-006',
    title: '美妆博主遭品牌方集体封杀，原因竟是私下挖墙脚',
    summary: '拥有八百万粉丝的美妆头部博主"妆点人生"被多家合作品牌同时解除合约，爆料称其在直播时贬低合作品牌，私下却向竞品品牌示好。',
    category: 'influencer',
    categoryName: '网红黑料',
    author: '圈内知情人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle%20aged%20Chinese%20business%20professional%20with%20knowing%20expression%2C%20wearing%20dark%20suit%2C%20neutral%20warm%20background%2C%20clean%20studio%20lighting&width=100&height=100&seq=avatar-006&orientation=squarish',
    publishDate: '2026-06-28',
    readTime: '5分钟',
    hotValue: 6230,
    image: 'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20broken%20cosmetics%20contract%20documents%20scattered%20with%20makeup%20products%20and%20lipsticks%20on%20marble%20surface%2C%20warm%20neutral%20tones%2C%20editorial%20beauty%20photography%20style%2C%20clean%20minimalist%20aesthetic&width=800&height=500&seq=article-006&orientation=landscape',
    tags: ['美妆博主', '封杀', '品牌方', '违约'],
    featured: false,
    content: `
      <p>近日，美妆圈传来劲爆消息，拥有八百万粉丝的头部博主"妆点人生"被至少五家合作品牌同时宣布解约， estimated违约金高达千万级别。</p>
      <p>据品牌方内部人士透露，该博主在直播中多次暗示自己代言的品牌"成分一般"、"性价比不高"，转头却在私下向竞品品牌抛出橄榄枝，开出更高的合作报价。</p>
      <p>更过分的是，有品牌方发现该博主在合同期内，偷偷为竞品品牌拍摄宣传素材，严重违反排他性条款。多家品牌联合取证后，决定同时采取法律行动。</p>
      <p>目前该博主已将争议视频全部删除，但互联网是有记忆的。吃瓜爆料提醒各位博主：商业诚信是立身之本。</p>
    `,
  },
  {
    id: 'article-007',
    title: '某选秀节目内幕曝光：排名全靠花钱买，出道位早已内定',
    summary: '前工作人员实名爆料某热门选秀节目存在严重黑幕，选手排名可通过后台操作调整，出道位在开播前就已经内定完毕。',
    category: 'daily',
    categoryName: '每日大赛',
    author: '前工作人员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Silhouette%20portrait%20of%20anonymous%20person%20with%20face%20hidden%20in%20shadows%2C%20mysterious%20atmospheric%20lighting%2C%20dark%20moody%20tone%2C%20investigative%20journalism%20style&width=100&height=100&seq=avatar-007&orientation=squarish',
    publishDate: '2026-06-27',
    readTime: '7分钟',
    hotValue: 11250,
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20dark%20tv%20studio%20control%20room%20with%20multiple%20monitors%20showing%20vote%20numbers%20and%20stage%20performance%2C%20dramatic%20red%20and%20blue%20monitor%20glow%20lighting%2C%20moody%20cinematic%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=article-007&orientation=landscape',
    tags: ['选秀', '内幕', '黑幕', '出道位'],
    featured: false,
    content: `
      <p>某热门选秀节目的前工作人员昨日在社交平台发布长文，详细披露了节目存在的多项黑幕操作，引发选秀粉丝圈大地震。</p>
      <p>据爆料，节目投票系统存在严重漏洞，所谓的"观众投票"实际上可以通过后台数据团队进行实时调整。该工作人员透露，曾亲眼目睹技术人员在决赛夜根据赞助商要求修改选手票数。</p>
      <p>更惊人的是，出道位在节目前期就已经与各大经纪公司谈妥，所谓"全民制作人"只是精心设计的剧本。某些选手从第一期开始就被安排好了剧本和人设，镜头量和故事线都是预先规划。</p>
      <p>该爆料已被多家媒体报道，节目制作方发布声明否认，但网友普遍不买账。吃瓜爆料将持续关注此事是否会引起监管部门的介入。</p>
    `,
  },
  {
    id: 'article-008',
    title: '富二代网红撞人逃逸后被扒出更多黑历史：酒驾、斗殴、威胁受害者',
    summary: '某知名富二代网红驾车撞人后逃逸，被警方拘留后其过往黑历史被网友逐一扒出，包括多次酒驾、打架斗殴、甚至曾威胁事故受害者。',
    category: 'social',
    categoryName: '社会热点',
    author: '正义使者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20male%20lawyer%20activist%20with%20determined%20expression%2C%20wearing%20formal%20attire%2C%20neutral%20warm%20background%2C%20clean%20studio%20lighting&width=100&height=100&seq=avatar-008&orientation=squarish',
    publishDate: '2026-06-26',
    readTime: '5分钟',
    hotValue: 13680,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20of%20luxury%20sports%20car%20accident%20on%20city%20street%20with%20police%20lights%20flashing%2C%20rain%20wet%20asphalt%20reflecting%20red%20and%20blue%20lights%2C%20cinematic%20film%20noir%20atmosphere%2C%20editorial%20photography%20style&width=800&height=500&seq=article-008&orientation=landscape',
    tags: ['富二代', '肇事逃逸', '黑历史', '酒驾'],
    featured: false,
    content: `
      <p>某社交平台坐拥三百万粉丝的富二代网红"Jack少爷"近日因驾车撞人后逃逸被警方拘留，而其过往劣迹被网友逐一扒出，震惊全网。</p>
      <p>据悉，该网红驾驶价值数百万的跑车在市区飙车，撞倒一名骑电动车的外卖员后未停车查看，直接驾车离开。外卖员腿部骨折，目前仍在医院治疗。</p>
      <p>网友深挖后发现，这并非其第一次犯事。此前该网红曾多次因酒驾被处罚，还在某夜店门口与人发生肢体冲突，甚至曾在一次事故后威胁受害者"你知道我爸是谁吗"。</p>
      <p>目前该网红已被警方依法刑事拘留，其社交账号也被平台封禁。吃瓜爆料将持续关注案件进展。</p>
    `,
  },
  {
    id: 'article-009',
    title: '某女团成员被曝霸凌队友，录音曝光内容触目惊心',
    summary: '某人气女团成员被前经纪人爆出霸凌队友的录音，内容涉及言语侮辱、排挤孤立、甚至威胁恐吓，引发饭圈大地震。',
    category: 'celebrity',
    categoryName: '明星八卦',
    author: '饭圈观察者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20female%20pop%20culture%20analyst%20with%20observant%20expression%2C%20trendy%20glasses%2C%20warm%20neutral%20background%2C%20clean%20studio%20lighting&width=100&height=100&seq=avatar-009&orientation=squarish',
    publishDate: '2026-06-25',
    readTime: '6分钟',
    hotValue: 9450,
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20studio%20photography%20of%20old%20cassette%20tape%20recorder%20with%20red%20recording%20light%20glowing%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20warm%20amber%20tones%20against%20dark%20background%2C%20editorial%20photography&width=800&height=500&seq=article-009&orientation=landscape',
    tags: ['女团', '霸凌', '录音', '队友'],
    featured: false,
    content: `
      <p>某当红女团的前经纪人昨日在社交平台放出多段录音，直指该团C位成员李某长期霸凌其他队友，内容之恶毒令人发指。</p>
      <p>录音中，李某用极其难听的词汇辱骂队友，称其"废物"、"拖油瓶"，还威胁"如果敢向公司告状就让你在圈子里混不下去"。更过分的是，李某还教唆粉丝去网暴某位队友，导致该队友一度抑郁停工。</p>
      <p>被霸凌的队友粉丝随即联合起来，整理了长达两年的证据链，包括聊天记录、现场目击证人证词等，要求公司给个说法。</p>
      <p>目前该女团原定的巡回演唱会已宣布延期，涉事成员所在公司发布声明称"正在调查"。吃瓜爆料将持续关注此事。</p>
    `,
  },
  {
    id: 'article-010',
    title: '知名情感博主被曝同时交往六名女粉丝，时间管理堪比海王',
    summary: '以"专一好男人"人设走红的情感博主被女粉丝联合爆料，同时与至少六名女粉丝保持恋爱关系，时间管理和聊天记录曝光后令人瞠目结舌。',
    category: 'influencer',
    categoryName: '网红黑料',
    author: '受害者联盟',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20group%20of%20young%20Chinese%20women%20standing%20together%20with%20determined%20expressions%2C%20supportive%20atmosphere%2C%20warm%20neutral%20background%2C%20clean%20studio%20lighting&width=100&height=100&seq=avatar-010&orientation=squarish',
    publishDate: '2026-06-24',
    readTime: '6分钟',
    hotValue: 10560,
    image: 'https://readdy.ai/api/search-image?query=Creative%20flat%20lay%20of%20multiple%20smartphones%20scattered%20on%20dark%20surface%20all%20showing%20dating%20app%20chat%20screens%20with%20heart%20icons%2C%20warm%20amber%20screen%20glow%2C%20moody%20cinematic%20atmosphere%2C%20editorial%20photography%20style&width=800&height=500&seq=article-010&orientation=landscape',
    tags: ['情感博主', '海王', '时间管理', '多角恋'],
    featured: false,
    content: `
      <p>拥有五百万粉丝的知名情感博主"真心导师"一直以"专一好男人"的人设著称，经常在视频中教导粉丝如何经营感情、识别渣男。然而讽刺的是，他近日被六名女粉丝联合爆料，同时与她们保持恋爱关系。</p>
      <p>六名女生建立了"受害者联盟"微信群，将各自与"真心导师"的聊天记录、约会时间表进行了比对整理。结果发现，该博主在同一周内分别与六名女生约会，行程密不透风，时间管理之精细令人叹为观止。</p>
      <p>更可笑的是，该博主给六名女生发送的情话竟然高度雷同，连表情包都一模一样。女生们将聊天记录制作成对比图，在网络上疯传。</p>
      <p>目前该博主已关闭所有社交账号评论区，其签约的MCN机构宣布解除合作关系。吃瓜爆料提醒各位：人设越完美，崩塌时越惨烈。</p>
    `,
  },
  {
    id: 'article-011',
    title: '某高校教授骚扰女学生，多名受害者勇敢站出来发声',
    summary: '某知名高校某学院教授被多名女学生实名举报存在性骚扰行为，涉及利用职务之便对女学生进行言语和肢体骚扰。',
    category: 'social',
    categoryName: '社会热点',
    author: '校园记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20female%20campus%20journalist%20with%20brave%20expression%2C%20wearing%20casual%20college%20style%2C%20warm%20neutral%20background%2C%20clean%20studio%20lighting&width=100&height=100&seq=avatar-011&orientation=squarish',
    publishDate: '2026-06-23',
    readTime: '7分钟',
    hotValue: 14200,
    image: 'https://readdy.ai/api/search-image?query=University%20campus%20building%20exterior%20at%20golden%20hour%20with%20dramatic%20long%20shadows%2C%20warm%20autumn%20light%2C%20academic%20atmosphere%2C%20editorial%20photography%20style%2C%20neutral%20warm%20tones&width=800&height=500&seq=article-011&orientation=landscape',
    tags: ['高校', '教授', '性骚扰', '实名举报'],
    featured: false,
    content: `
      <p>某知名高校某学院近日陷入舆论漩涡，该院一名教授被至少五名女学生在网络平台上实名举报存在性骚扰行为。</p>
      <p>据受害者之一的小王（化名）描述，该教授多次以"单独辅导"为由将其叫到办公室，期间存在不适当的肢体接触和言语暗示。另一名受害者小李则称，教授曾在微信上发送露骨信息，被拒绝后还以"影响毕业"进行威胁。</p>
      <p>五名受害者勇敢地站了出来，联合整理了长达半年的证据，包括聊天记录、录音、证人证词等，向学校纪委和公安机关同时进行了举报。</p>
      <p>该校已发布公告表示高度重视，已成立专项调查组，涉事教授已被暂停教学和科研工作。吃瓜爆料为勇敢发声的受害者们点赞。</p>
    `,
  },
  {
    id: 'article-012',
    title: '昨日吃瓜大赛结果出炉：高校教授骚扰案以绝对优势夺冠',
    summary: '吃瓜爆料每日大赛昨日赛果公布，高校教授性骚扰案以72%的得票率碾压其他对手，当选昨日最震撼瓜王。',
    category: 'daily',
    categoryName: '每日大赛',
    author: '吃瓜大赛组委会',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fun%20colorful%20illustration%20of%20a%20watermelon%20slice%20character%20mascot%20wearing%20gold%20crown%20and%20holding%20trophy%2C%20cute%20cartoon%20style%2C%20vibrant%20colors%2C%20clean%20white%20background&width=100&height=100&seq=avatar-012&orientation=squarish',
    publishDate: '2026-06-24',
    readTime: '3分钟',
    hotValue: 7890,
    image: 'https://readdy.ai/api/search-image?query=Celebratory%20scene%20with%20golden%20trophy%20and%20confetti%20on%20dark%20elegant%20surface%2C%20dramatic%20spotlight%20lighting%2C%20warm%20gold%20and%20amber%20tones%2C%20award%20ceremony%20atmosphere%2C%20editorial%20photography%20style&width=800&height=500&seq=article-012&orientation=landscape',
    tags: ['每日大赛', '赛果', '瓜王', '投票结果'],
    featured: false,
    content: `
      <p>吃瓜爆料每日大赛昨日赛果正式出炉！经过十二小时的激烈投票，最终高校教授性骚扰案以绝对优势当选"昨日瓜王"。</p>
      <p>最终投票结果：</p>
      <p>选手A：高校教授骚扰女学生案 —— 72%（14520票）</p>
      <p>选手B：情感博主海王时间管理案 —— 28%（5640票）</p>
      <p>恭喜"高校教授骚扰女学生案"以碾压性优势夺得昨日瓜王称号！该瓜料在爆出后迅速登上多个平台热搜，引发全社会对校园性骚扰问题的关注和讨论。</p>
      <p>今日的吃瓜大赛正在火热进行中，快来投出你的一票，选出你心中的今日瓜王！</p>
    `,
  },
];